import React from 'react';
import PropTypes from 'prop-types';

import SelectFilter from '../design/shared/filter/selectFilter';
import MultiSelectFilter from '../design/shared/filter/multiSelectFilter';
import { Box } from '../design/css';

const SelectFilters = ({ filters }) => {
  return filters.map(filter => {
    const {
      id,
      label,
      placeholder,
      options,
      value,
      defaultValue,
      onChange,
      isMultiSelect
    } = filter;

    return (
      <Box key={label} width={30} mdWidth={100} pb={24} pr={16}>
        {isMultiSelect ? (
          <MultiSelectFilter
            name={id}
            label={label}
            options={options}
            value={value}
            updateFilters={onChange}
          />
        ) : (
          <SelectFilter
            label={label}
            placeholder={placeholder}
            options={options}
            value={value}
            onChange={onChange}
            defaultValue={defaultValue}
          />
        )}
      </Box>
    );
  });
};

SelectFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.object).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
        .isRequired,
      defaultValue: PropTypes.string,
      onChange: PropTypes.func.isRequired
    })
  ).isRequired
};

export default SelectFilters;
